import React from 'react';
import { Switch, Route } from "react-router-dom";
import { ThemeProvider } from '@material-ui/core/styles';
import CssBaseline from "@material-ui/core/CssBaseline";
import Container from "@material-ui/core/Container";
import { Header, Sidebar, Content } from 'layout/components';
import { Routes } from 'components/app/Routes';
import { theme } from 'layout/theme';

const Layout = () => {
  return (
    <div>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <Container style={{ marginTop: "100px" }}>
          <Header />
          <Sidebar />
          <Content>
            <Routes />
          </Content>
        </Container>
      </ThemeProvider>
    </div>
  );
}

const AppLayout = (props) => {
  return (
    <div>
      <Switch>
        <Route path="/" component={Layout} />
      </Switch>
    </div>
  );
}

export default AppLayout;